import { render, staticRenderFns } from "./CreateEditContent.vue?vue&type=template&id=672c40ba&scoped=true&"
import script from "./CreateEditContent.vue?vue&type=script&lang=js&"
export * from "./CreateEditContent.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditContent.vue?vue&type=style&index=0&id=672c40ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c40ba",
  null
  
)

export default component.exports